import Fuse from 'fuse.js';
import { BookMarkedIcon } from 'lucide-react';

import { type Collection } from '@/shared/types/collections';

import { type EntityResult } from '../../types';
import { MAX_PER_TYPE } from '../../utils';

/**
 * Searches knowledge bases (collections) using a pre-built Fuse instance.
 * Returns up to MAX_PER_TYPE results sorted by fuzzy match score.
 */
export const searchCollections = (query: string, fuse: Fuse<Collection> | null): EntityResult[] => {
  if (!fuse) {
    return [];
  }

  return fuse
    .search(query, { limit: MAX_PER_TYPE })
    .map(({ item: c, score }) => ({
      id: c.collection_id,
      name: c.name,
      type: 'knowledge_base' as const,
      path: `/knowledge-bases/${c.collection_id}/category/all`,
      icon: BookMarkedIcon,
      score: 1 - (score ?? 0),
    }));
};
